module.exports = __webpack_public_path__ + "img/vanax.1c9e43e8.jpg";